import api from '@/services/api'

export default {
  async getCurrent (userId) {
    try {
      const res = await api.get('/users/' + userId + '/entries/current')
      return res.data
    } catch (error) {
      throw `Entries api service ${error}`
    }
  },

  async getUserEntriesByPeriod (userId, {startDate, endDate}) {
    try {
      const res = await api.get('/users/' + userId + '/entries/period', {params: {start: startDate, end: endDate}})
      return res.data
    } catch (error) {
      throw `Entries api service ${error}`
    }
  },

  async generateNext (userId) {
    try {
      const res = await api.post('/users/' + userId + '/entries/current')
      return res.data
    } catch (error) {
      throw `Entries api service ${error}`
    }
  },

  async updateEntry (entry) {
    try {
      const res = await api.put('/entries/' + entry.id, entry)
      return res.data
    } catch (error) {
      throw `Entries api service ${error}`
    }
  },

  async send (userId) {
    try {
      const res = await api.patch('/users/' + userId + '/entries/current/send')
      return res.data
    } catch (error) {
      throw `Entries api service ${error}`
    }
  }
}